import { combineReducers } from "redux";
import {
  FETCH_ALL_SPEAKERS,
  FETCH_SPEAKERS,
  DELETE_SPEAKERS_SUCESS,
  DELETE_SPEAKERS_ERROR,
  UPDATED_SPEAKER_IMAGE,
  OPEN_SPEAKER_MODAL,
  LOAD_EDIT_SPEAKER_DATA,
  UPDATE_SPEAKERS_FILES,
  SPEAKER_FILES_CHANGED,
  IMPORT_SPEAKER_MODAL,
  SPEAKER_COUNTING_NUMBERS,
} from "ActionsSpeakers";

export function allSpeakersReducers(state = [], action) {
  switch (action.type) {
    case FETCH_ALL_SPEAKERS:
      return action.payload;
    default:
      return state;
  }
}
export function SpeakersReducers(state = [], action) {
  switch (action.type) {
    case FETCH_SPEAKERS:
      return action.payload;
    default:
      return state;
  }
}

export function openSpeakerPopup(state = [], action) {
  switch (action.type) {
    case OPEN_SPEAKER_MODAL:
      return action.payload;
    default:
      return state;
  }
}

export function loadEditSpeakerData(state = {}, action) {
  switch (action.type) {
    case LOAD_EDIT_SPEAKER_DATA:
      return action.payload;
    default:
      return state;
  }
}

export function speakerImageReducer(state = null, action) {
  switch (action.type) {
    case UPDATED_SPEAKER_IMAGE:
      return action.payload;
    default:
      return state;
  }
}

export function speakerfilesList(
  state = [
    { position: "file1", file: "", filename: "" },
    { position: "file2", file: "", filename: "" },
    { position: "file3", file: "", filename: "" },
    { position: "file4", file: "", filename: "" },
    { position: "file5", file: "", filename: "" },
  ],
  action
) {
  switch (action.type) {
    case UPDATE_SPEAKERS_FILES:
      return action.payload;
    default:
      return state;
  }
}

export function speakerfilesChanged(state = { ischanged: false }, action) {
  switch (action.type) {
    case SPEAKER_FILES_CHANGED:
      return action.payload;
    default:
      return state;
  }
}

export function importSpeakerModal(state = [], action) {
  switch (action.type) {
    case IMPORT_SPEAKER_MODAL:
      return action.payload;
    default:
      return state;
  }
}

export function speakersCount(state = {}, action) {
  switch (action.type) {
    case SPEAKER_COUNTING_NUMBERS:
      return action.payload;
    default:
      return state;
  }
}
